import React, { Component } from 'react';
import { connect } from 'react-redux';

export default function(ComposedComponent) {
	class Authentication extends Component {
		componentWillMount() {
			if (!this.props.isAuthenticated) {
				this.props.history.push('/');
			}
		}

		componentWillUpdate(nextProps) {
			if (!nextProps.isAuthenticated) {
				this.props.history.push('/');
			}
		}

		render() {
			return <ComposedComponent {...this.props} />;
		}
	}

	const mapStateToProps = ({ login }) => ({
		isAuthenticated: login.isAuthenticated || localStorage.getItem('Hello') !== null
	});

	return connect(mapStateToProps)(Authentication);
}
